export default "__VITE_ASSET__CZccWuPp__"